import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import { withLocalePrefix } from 'shared/utils/translation';

// The common stuff for the candidate filter in App Review and MyGH tabs

const t = withLocalePrefix('talent_matching.filter_row.grouped_buttons');

type Props = {
  appliedCount: number;
  onClear: () => void;
  width?: string;
  children: React.ReactNode;
};

const CandidateFiltersGroupLayout = ({
  appliedCount,
  onClear,
  width = '520px',
  children,
}: Props) => {
  const buttonLabel = `${t('candidate')}${
    appliedCount ? ` (${appliedCount})` : ''
  }`;

  return (
    <PopoverButton
      buttonLabel={buttonLabel}
      title={t('candidate_filters')}
      width={width}
    >
      <Stack spacing={3}>
        {children}
        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={onClear} size="lg">
            {t('clear')}
          </TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default CandidateFiltersGroupLayout;
